module.exports = __webpack_public_path__ + "static/media/play_image.6f46bd87.jpg";